import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ArtifactReferenceImage {
  imagePath: string;
  imageName: string;
  uploadVerified: boolean;
  signedUrl: string;
}

export interface Artifact {
  artifactId: string;
  projectId: string;
  artifactName: string;
  artifactDescription: string;
  category: string;
  keywords: string[];
  artifactReferenceImages: ArtifactReferenceImage[];
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
}

export interface ArtifactMap {
  [keyword: string]: Artifact[];
}

interface ArtifactState {
  artifactsMap: ArtifactMap;
  artifacts: Artifact[];
}

const initialState: ArtifactState = {
  artifactsMap: {},
  artifacts: [],
};

function createKeywordMap(artifacts: Artifact[]): ArtifactMap {
  const map: ArtifactMap = {};
  artifacts.forEach((artifact) => {
    artifact.keywords.forEach((keyword) => {
      if (!map[keyword]) {
        map[keyword] = [];
      }
      map[keyword].push(artifact);
    });
  });
  return map;
}

const artifactSlice = createSlice({
  name: "artifact",
  initialState,
  reducers: {
    setArtifactsMap: (state, action: PayloadAction<Artifact[]>) => {
      state.artifactsMap = createKeywordMap(action.payload);
    },
    setArtifacts: (state, action: PayloadAction<Artifact[]>) => {
      state.artifacts = action.payload;
    },
    // addArtifact: (state, action: PayloadAction<Artifact>) => {
    //   state.artifacts.push(action.payload);
    // },
    // removeArtifact: (state, action: PayloadAction<string>) => {
    //   state.artifacts = state.artifacts.filter(
    //     (artifact) => artifact.id !== action.payload
    //   );
    // },
    // updateArtifact: (state, action: PayloadAction<Artifact>) => {
    //   const index = state.artifacts.findIndex(
    //     (artifact) => artifact.id === action.payload.id
    //   );
    //   if (index !== -1) {
    //     state.artifacts[index] = action.payload;
    //   }
    // },
  },
});

export const { setArtifacts, setArtifactsMap } = artifactSlice.actions;

export default artifactSlice.reducer;
